import { AbsenceBadge } from "../../../../components/ui/AbsenceBadge";
import { Table } from "../../../../components/ui/Table";
import { formatName } from "../../../../services/functions";
import {
  formatCurrency,
  formatNumber,
  formatDateTime,
} from "../helpers";
import { ResultyStatusBadge } from "./ResultyStatusBadge";
import { RuleBadge } from "../components/RuleBadge";

export function ResultyRow({ attempt }) {
  const absenceDays = attempt.opportunity?.daysSinceLastAppointment;

  return (
    <Table.Line>
      <Table.Item>
        <AbsenceBadge days={absenceDays} />
      </Table.Item>
      <Table.Item>
        <div className="flex flex-wrap gap-1">
          {(attempt.ruleCodes || []).map((ruleCode) => (
            <RuleBadge key={ruleCode} ruleCode={ruleCode} />
          ))}
        </div>
      </Table.Item>
      <Table.Item>
        <div className="flex flex-col">
          <strong>{formatName(attempt.customerName || "Cliente não informado")}</strong>
          <span className="text-xs text-gray-500">
            Pet: {formatName(attempt.sourcePetName || "—")}
            {attempt.activePetsCount > 1 ? ` · ${attempt.activePetsCount} pets ativos` : ""}
          </span>
        </div>
      </Table.Item>
      <Table.Item>
        <strong> {formatNumber(attempt.contactCount)}</strong> {attempt.contactCount === 1 ? 'contato' : 'contatos'}
      </Table.Item>
      <Table.Item>
        {formatDateTime(attempt.firstContactAt)}
      </Table.Item>
      <Table.Item>
        {formatDateTime(attempt.lastContactAt)}
      </Table.Item>
      <Table.Item><ResultyStatusBadge status={attempt.status} /></Table.Item>
      <Table.Item>{formatCurrency(attempt.totals?.serviceRevenue)}</Table.Item>
      <Table.Item>{formatCurrency(attempt.totals?.productRevenue)}</Table.Item>
      <Table.Item>
        <div className="flex flex-col">
          <strong>{formatCurrency(attempt.totals?.totalRevenue)}</strong>
          <span className="text-xs text-gray-500">
            Até agendar: {formatNumber(attempt.contactsUntilSchedule)} contato(s)
          </span>
        </div>
      </Table.Item>
    </Table.Line >
  );
}
